export function LegalPage({ title, children }) {
  return (
    <div data-testid={`page-legal-${title.toLowerCase().replace(/\s/g, "-")}`} className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-16 max-w-3xl">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">Legal</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-[1]">{title}</h1>
      </section>
      <section className="container-editorial pb-24 max-w-3xl prose prose-lg text-[#2B2927]">{children}</section>
    </div>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <p>We take your privacy seriously. This policy describes what personal data Hiraya collects, why, and how we store it.</p>
      <h3 className="font-serif text-2xl mt-8">What we collect</h3>
      <p>When you fill in a contact or consultation form, we collect your name, contact details, and any project details you share. We do not sell or share your data with third parties.</p>
      <h3 className="font-serif text-2xl mt-8">How we use it</h3>
      <p>We use the information only to respond to your enquiry, schedule consultations, and manage active projects. Enquiry records are retained for 24 months and then archived or deleted.</p>
      <h3 className="font-serif text-2xl mt-8">Your rights</h3>
      <p>You can ask to see, correct, or delete your personal information at any time by writing to us.</p>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms and Conditions">
      <p>By using this website, you agree to these terms. All content, imagery and copy on this site are © Hiraya unless credited otherwise.</p>
      <h3 className="font-serif text-2xl mt-8">Use of content</h3>
      <p>You may not reproduce, republish, or use images from this site for any commercial purpose without prior written permission from Hiraya.</p>
      <h3 className="font-serif text-2xl mt-8">No warranty</h3>
      <p>Information is provided in good faith and to the best of our knowledge. Project timelines and costs on this site are indicative only.</p>
    </LegalPage>
  );
}

export function Cookies() {
  return (
    <LegalPage title="Cookie Policy">
      <p>This website uses a small number of cookies — essential cookies for site functionality, and optional analytics cookies to help us improve our content.</p>
      <p>You can control cookies through your browser settings. Disabling essential cookies may affect site functionality.</p>
    </LegalPage>
  );
}
